import _ from "lodash";
import { isVirtualProduct } from "@estaly/ui";

export function buildLeadParams(subscription, includeProduct) {
  const params = {
    lead: _.pick(subscription, [
      "customer",
      "address",
      ...(includeProduct ? ["product"] : []),
      "invitationSentByEstaly",
      "paymentInStorePlatform",
      "sellerId",
      "category",
      "advisoryAnswer",
    ]),
  };

  if (includeProduct && params.lead.product) {
    const product = { ...params.lead.product };

    if (isVirtualProduct(product)) {
      params.lead.transactionDate = product.transactionDate;
      delete product.transactionDate;
      delete product.lineHolderName;
      product.price = null;
    } else {
      delete product.transactionDate;
      delete product.lineHolderName;
      delete product.productNature;
    }

    params.lead.product = product;
  }

  return params;
}
